import type { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import type { ValueOf } from 'type-fest';

export enum SettingsFormType {
  advancedCheckbox = 'advancedCheckbox',
  avatar = 'avatar',
  checkbox = 'checkbox',
  chips = 'chips',
  input = 'input',
  number = 'number',
  select = 'select',
  toggle = 'toggle',
}

export interface FormGroupTemplate extends BaseFormGroupTemplate {
  forms?: FormControlTemplate[];
}

export interface FormSettingTemplate extends BaseFormGroupTemplate {
  formInformation: FormControlTemplate;
}

interface BaseFormGroupTemplate {
  actions?: {
    color?: string;
    href?: string;
    raised?: boolean;
    text?: string;
    disable?: boolean;
    callback?(forms?: any): void;
  }[];
  containerClass?: string;
  description?: string;
  disableActionBar?: boolean;
  disableForms?: boolean;
  disableFormsText?: string;
  headerAction?: {
    color?: string;
    icon?: string;
    model?: any;
    name?: string;
    text?: string;
    type?: string;
    updateKey?: string;
    callback?(updatedFormModel?: any): void;
  };
  title?: {
    primaryIcon?: string;
    secondaryIcon?: string;
    text?: string;
  };
  type?: string;
  validators?: any[];

  formsCallback?(formGroupValue: any): void;
}

export interface FormGroupItemTemplate<TKey extends string, TValue>
  extends FormControlTemplate<TValue> {
  updateKey: TKey;
}

export type FormGroupTemplateArray<TValue> = ReadonlyArray<
  ValueOf<FormGroupValuesForTemplate<TValue>>
>;
type FormGroupValuesForTemplate<TValue> = {
  [K in keyof TValue]: FormGroupItemTemplate<Extract<K, string>, TValue[K]>;
};

export type FormGroupTemplateArrayForControl<
  TControl extends { [K in keyof TControl]: AbstractControl },
> = ReadonlyArray<ValueOf<FormGroupControlsForTemplate<TControl>>>;
type FormGroupControlsForTemplate<
  TControl extends { [K in keyof TControl]: AbstractControl },
> = {
  [K in keyof TControl]: FormControlTemplateForControl<
    Extract<K, string>,
    TControl[K]
  >;
};
type FormControlTemplateForControl<
  TKey extends string,
  TControl extends AbstractControl,
  TValue = TControl['value'],
> = FormGroupItemTemplate<TKey, TValue> &
  (TControl extends FormGroup<infer GroupControls>
    ? {
        formGroup: FormGroupTemplateArrayForControl<GroupControls>;
        model?: never;
      }
    : { formGroup?: never; model: TValue });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface FormControlTemplate<TValue = any> {
  data?: {
    disable?: boolean;
    documentType?: string;
    inputType?: string;
    label?: string;
    limit?: number;
    max?: number;
    min?: number;
    suffix?: string;
    options?: {
      text?: any;
      value?: any;
    }[];
    placeholder?: string;
  };
  disable?: boolean;
  formGroup?: FormGroupTemplateArray<TValue>;
  hide?: boolean;
  model?: TValue;
  subForms?: FormControlTemplate[];
  type?: SettingsFormType;
  label?: string;
  showLabel?: boolean;
  subLabel?: string;
  updateKey?: string;
  validators?: ValidatorFn[];

  callback?(form: any): void;
}
